import { render, staticRenderFns } from "./ModalLabelTransfers.vue?vue&type=template&id=2833597a&lang=pug&"
import script from "./ModalLabelTransfers.vue?vue&type=script&lang=js&"
export * from "./ModalLabelTransfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports